/**
 * Defines purchase age bands in whole calendar months.
 *
 * These ranges are consumed by the PostHog purchase-time-band utility after
 * month age is calculated via the shared `calculateAgeInMonths` helper.
 */
export const timeBands = [
  { name: 'Under 1 month', min: 0, max: 0 },
  { name: '1 - 2 months', min: 1, max: 1 },
  { name: '2 - 3 months', min: 2, max: 2 },
  { name: '3 - 4 months', min: 3, max: 3 },
  { name: '4 - 5 months', min: 4, max: 4 },
  { name: '5 - 6 months', min: 5, max: 5 },
  { name: '6 - 12 months', min: 6, max: 11 },
  { name: '12 - 18 months', min: 12, max: 17 },
  { name: '18 months +', min: 18, max: Infinity },
];
